import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import ButtonComponent from '@prisjakt/ui-button';

const LogoWrapper = styled.div`
  display: flex;

  ${media.mediumDown`
    float: right;
  `}
`;

const Logo = styled.div`
  flex: 1 0 auto;
  width: 116px;
  height: 24px;

  ${media.mediumDown`
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${layout.spacing.xSmall};
    margin-left: ${layout.spacing.small};
  `}
`;

const BannerText = styled.div(
  props => css`
    a {
      text-decoration: underline;
      color: ${p => p.theme.cookieBanner.fg};
      white-space: nowrap;
    }

    ${media.mediumDown`
      padding: 0;
      margin-bottom: ${layout.spacing.small};
    `}
  `
);

const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: ${layout.spacing.medium};
  color: ${p => p.theme.cookieBanner.fg};
  background: ${p => p.theme.cookieBanner.bg};
  z-index: 999;

  ${media.mediumDown`
    padding: ${layout.spacing.small};
  `}
`;

const PrivacyLink = styled.p`
  margin-bottom: 0;
  margin-top: ${layout.spacing.xSmall};
`;

const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  max-width: 300px;

  ${media.mediumDown`
    max-width: 100%;
    flex-direction: row;
  `}
`;

const Button = styled(ButtonComponent)`
  margin-bottom: ${layout.spacing.xSmall};
  height: 40px;
  width: 50%;

  ${media.mediumDown`
    margin-bottom: 0;
    margin-left: ${layout.spacing.xxSmall};
  `}
`;

const AcceptButton = styled(Button).attrs({
  'data-test': 'CookieBannerAcceptButton',
})`
  margin-right: ${layout.spacing.xSmall};

  ${media.mediumDown`
    margin-right: ${layout.spacing.xxSmall};
    margin-left: 0;
  `}
`;

const RejectButton = styled(Button).attrs({
  'data-test': 'CookieBannerRejectButton',
})`
  margin-right: ${layout.spacing.xSmall};

  ${media.mediumDown`
    margin-right: ${layout.spacing.xxSmall};
    margin-left: 0;
  `}
`;

const BannerContent = styled.div(
  props => css`
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    height: 100%;
    font-size: 12px;

    > * {
      margin-right: ${layout.spacing.large};
    }

    ${media.mediumDown`
      flex-direction: column;

      > * {
        margin-right: 0;
      }
    `}
  `
);

export {
  Banner,
  BannerContent,
  BannerText,
  ButtonsWrapper,
  Button,
  AcceptButton,
  RejectButton,
  LogoWrapper,
  Logo,
  PrivacyLink,
};
